"use client";

import BookForMeRequestSummary from "./BookForMeRequestSummary";
import { BookForMeHelpBanner } from "./BookForMeComponents";
import { memo, useCallback } from "react";
import { useRouter } from "@/i18n/navigation";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BookForMeFormData } from "../book-for-me.type";

interface BookForMeSuccessViewProps {
  data: BookForMeFormData;
  onBackToHome?: () => void;
  onViewMyRequest?: () => void;
}

export const BookForMeSuccessView = memo(function BookForMeSuccessView({
  data,
  onBackToHome,
  onViewMyRequest,
}: BookForMeSuccessViewProps) {
  const router = useRouter();

  const handleBackToHome = useCallback(() => {
    if (onBackToHome) {
      onBackToHome();
      return;
    }
    router.push("/");
  }, [onBackToHome, router]);

  const handleViewMyRequest = useCallback(() => {
    if (onViewMyRequest) {
      onViewMyRequest();
      return;
    }
    router.push("/account-settings/my-trips");
  }, [onViewMyRequest, router]);

  return (
    <main>
      <div className="space-y-4">
        <div className="flex flex-col-reverse lg:flex-row justify-between gap-4 lg:flex-row items-stretch">
          {/* Left Column: Your request summary */}
          <section className="w-full lg:w-[65%] space-y-4">
            <BookForMeRequestSummary data={data} />
            <BookForMeHelpBanner />
          </section>

          {/* Right Column: Finding a hotel card */}
          <section className="w-full lg:w-[35%] self-stretch">
            <Card className="h-fit rounded-3xl border-none bg-white shadow-product-card flex flex-col items-center justify-center text-center">
              <div className="flex flex-wrap items-center justify-center gap-3 w-full">
                <Button
                  type="button"
                  variant="outline"
                  size="md"
                  onClick={handleBackToHome}
                  className="flex-1"
                >
                  Back to home
                </Button>
                <Button
                  type="button"
                  size="md"
                  onClick={handleViewMyRequest}
                  className="flex-1"
                >
                  View My Request
                </Button>
              </div>
            </Card>
          </section>
        </div>
      </div>
    </main>
  );
});

export default BookForMeSuccessView;
